import { z } from 'zod'

export default z.string({ required_error: 'value is required' }).email()
